module.exports = __webpack_public_path__ + "img/顶部@2x.cf037409.png";